import React, { Component } from "react";
import Link from "screens/home/components/link";
import HomepageVideoPlayer from "components/VideoPlayer/HomePageVideoPlayer";
import "./hero.css";
import { createImgLoader } from "../../LazyImgLoader";

import Devices from "./assets/devices.png";

export default class Hero extends Component {
  componentDidMount() {
    createImgLoader();
  }

  render() {
    const videoUrl =
      "https://jetsweat-assets.s3.amazonaws.com/homepage-video-latest.m3u8";
    return (
      <div>
        <div className="js-home-hero-container">
          <HomepageVideoPlayer videoUrl={videoUrl}></HomepageVideoPlayer>

          <h1 className="js-raleway js-font-white js-font-65 js-font-30-mb js-font-medium js-home-hero-text d-flex align-items-end">
          The best of boutique fitness & wellness - anytime, anywhere          </h1>
        </div>
        <div className="d-flex flex-md-row-reverse flex-column js-home-hero-row align-items-center">
          <div>
            <img
              alt="desktop browser studios tab woman is working out and next to the desktop browser mobile image with running  Jetsweat app"
              className="js-home-hero-devices-img"
              data-src={Devices}
            />
          </div>
          <div className="d-flex flex-column align-items-md-start align-items-center">
            <p className="js-open-sans js-font-25 js-font-18-mb js-font-3D3D3D js-home-hero-cta-description">
              Whether you're at home or on-the-go —crush your mind AND body goals with hundreds of on-demand classes & sessions from top boutique fitness + wellness brands in every category.
            </p>
            <Link
              className="js-home-hero-cta-button js-home-hero-cta-button-link"
              color="light-green"
              label="Start your free trial"
              href="/signup"
            />
          </div>
        </div>
      </div>
    );
  }
}
